import type {
  ChannelPartnerPrivateOffer,
  CppoStages,
} from '../../../modules/channelPartnerPrivateOffer/reducer'
import { OfferStatus } from '../../../modules/privateOffer/reducer'
import { getChannelOfferStagesData } from '../../../utils/channelOfferUtil'

export const buildCppoAuditJson = (
  channelPrivateOffer?: ChannelPartnerPrivateOffer
): CppoStages => ({
  'Created at Labra':
    channelPrivateOffer?.auditJson?.offerCreatedInLabraAt ?? '',
  Sent: channelPrivateOffer?.auditJson?.offerEmailSentAt ?? '',
  Viewed: channelPrivateOffer?.auditJson?.offerViewedAt ?? '',
  Cancelled: channelPrivateOffer?.auditJson?.offerCancelledAt ?? '',
  Accepted: channelPrivateOffer?.auditJson?.offerAcceptedAt ?? '',
})

export const getFilteredChannelOfferStages = (
  auditJson: CppoStages,
  offerStatus?: OfferStatus
) => {
  const stageDataArray = getChannelOfferStagesData(
    auditJson,
    offerStatus as OfferStatus
  )
  return stageDataArray
    ?.filter(obj => obj.display === true)
    ?.sort((a, b) => a.sortOrder - b.sortOrder)
}
